// Backend `Service/Helper/AccessModule.cs` ile birebir senkronize tutulmali.
export const ACCESS_MODULES = {
    RUN_CHECK: 'run.check',
    RUN_COMPARE: 'run.compare',
    RUN_FIX: 'run.fix',
    RUN_LMA: 'run.lma',
    RUN_SURVEY_AUTOMATION: 'run.survey_automation',
    RUN_XS_AUTOMATION: 'run.xs_automation',

    CHECK_OVERVIEW: 'check.overview',
    CHECK_CROSS_SECTION: 'check.cross_section',
    CHECK_STRUCTURE: 'check.structure',
    CHECK_RT_COEFFICIENT: 'check.rt_coefficient',
    CHECK_SCHEMATIC: 'check.schematic',
    CHECK_FLOW: 'check.flow',
    CHECK_FLOODWAY: 'check.floodway',
    CHECK_OUTPUTS: 'check.outputs',
    CHECK_WSEL_LIBRARY: 'check.wsel_library',
    CHECK_SURVEY_DATA: 'check.survey_data',

    COMPARE_OVERVIEW: 'compare.overview',
    COMPARE_CROSS_SECTION: 'compare.cross_section',
    COMPARE_STRUCTURE: 'compare.structure',
    COMPARE_RT_COEFFICIENT: 'compare.rt_coefficient',
    COMPARE_SCHEMATIC: 'compare.schematic',
    COMPARE_FLOW: 'compare.flow',
    COMPARE_FLOODWAY: 'compare.floodway',
    COMPARE_OUTPUTS: 'compare.outputs',
};

// Operations.js icindeki ust grup basliklari (CheckOperations / ComparisonOperations)
// ile permission anahtarlari arasindaki esleme.
const CHECK_GROUP_TO_MODULE = {
    'Overview': ACCESS_MODULES.CHECK_OVERVIEW,
    'Cross Section': ACCESS_MODULES.CHECK_CROSS_SECTION,
    'Structure': ACCESS_MODULES.CHECK_STRUCTURE,
    'R/T Coefficient': ACCESS_MODULES.CHECK_RT_COEFFICIENT,
    'Schematic': ACCESS_MODULES.CHECK_SCHEMATIC,
    'Flow': ACCESS_MODULES.CHECK_FLOW,
    'Floodway': ACCESS_MODULES.CHECK_FLOODWAY,
    'Outputs': ACCESS_MODULES.CHECK_OUTPUTS,
    'WSEL Library': ACCESS_MODULES.CHECK_WSEL_LIBRARY,
    'Survey Data': ACCESS_MODULES.CHECK_SURVEY_DATA,
};

const COMPARE_GROUP_TO_MODULE = {
    'Overview': ACCESS_MODULES.COMPARE_OVERVIEW,
    'Cross Section': ACCESS_MODULES.COMPARE_CROSS_SECTION,
    'Structure': ACCESS_MODULES.COMPARE_STRUCTURE,
    'R/T Coefficient': ACCESS_MODULES.COMPARE_RT_COEFFICIENT,
    'Schematic': ACCESS_MODULES.COMPARE_SCHEMATIC,
    'Flow': ACCESS_MODULES.COMPARE_FLOW,
    'Floodway': ACCESS_MODULES.COMPARE_FLOODWAY,
    'Outputs': ACCESS_MODULES.COMPARE_OUTPUTS,
};

export function getPermissionSet(user) {
    if (!user) return new Set();
    if (user?.data?.isAdmin) return null; // null = unrestricted (admin sees everything)
    return new Set(user?.data?.permissions || []);
}

export function hasPermission(permSet, key) {
    if (permSet === null) return true; // admin
    return permSet.has(key);
}

export function getCheckGroupPermissionKey(groupTitle) {
    return CHECK_GROUP_TO_MODULE[groupTitle] || null;
}

export function getCompareGroupPermissionKey(groupTitle) {
    return COMPARE_GROUP_TO_MODULE[groupTitle] || null;
}

export function filterRunOperations(runType, operations, permSet) {
    const resolver = runType === 'Check' ? getCheckGroupPermissionKey : getCompareGroupPermissionKey;
    return operations.filter((op) => {
        const key = resolver(op.title);
        if (!key) return true;
        return hasPermission(permSet, key);
    });
}
